import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import API from '../services/api';
import logo from '../assets/landinglogo.jpg';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setStatus('error');
      setMessage('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    setStatus(null);
    try {
      const res = await API.post('/auth/reset-password', { token, password });
      setMessage(res.data.message);
      setStatus('success');
    } catch (err) {
      setMessage(err.response?.data?.message || 'Something went wrong. Please try again.');
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', justifyContent: 'flex-start', alignItems: 'center', background: 'var(--surface-muted)', paddingTop: '4rem' }}>
        <div style={{ background: '#fff', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '2rem', width: '320px', textAlign: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
          <p style={{ color: 'var(--error-color)', marginBottom: '1rem' }}>Invalid or missing reset token.</p>
          <Link to="/forgot-password" style={{ color: 'var(--accent-color)' }}>Request a new reset link</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', justifyContent: 'flex-start', alignItems: 'center', background: 'var(--surface-muted)', paddingTop: '4rem' }}>
      <div style={{ background: '#fff', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '2rem', width: '320px', textAlign: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
        <img src={logo} alt="Logo" style={{ width: '175px', marginBottom: '1rem' }} />

        <h2 style={{ marginBottom: '0.5rem', fontSize: '1.2rem' }}>Set New Password</h2>

        {status === 'success' ? (
          <div>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✅</div>
            <p style={{ color: 'var(--accent-color)', fontWeight: 600, marginBottom: '0.5rem' }}>Password updated!</p>
            <p style={{ color: 'var(--text-strong)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>You can now log in with your new password.</p>
            <Link to="/" style={{ display: 'inline-block', padding: '0.75rem 1.5rem', backgroundColor: 'var(--accent-color)', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontSize: '0.95rem' }}>
              Go to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
              <label style={{ fontSize: '0.9rem' }}>New Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                minLength={8}
                placeholder="At least 8 characters"
                style={{ width: '100%', padding: '0.5rem', boxSizing: 'border-box', marginTop: '0.25rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}
              />
            </div>
            <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
              <label style={{ fontSize: '0.9rem' }}>Confirm Password</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
                placeholder="Repeat your new password"
                style={{ width: '100%', padding: '0.5rem', boxSizing: 'border-box', marginTop: '0.25rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}
              />
            </div>

            {status === 'error' && (
              <p style={{ color: 'var(--error-color)', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{message}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: '0.75rem', backgroundColor: 'var(--accent-color)', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1rem', opacity: loading ? 0.7 : 1 }}
            >
              {loading ? 'Saving…' : 'Reset Password'}
            </button>

            <div style={{ marginTop: '1rem' }}>
              <Link to="/" style={{ color: 'var(--accent-color)', fontSize: '0.9rem' }}>← Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
